import { NAME } from './reducer'

export const getQuery = (state) => state[NAME].query
export const getResults = (state) => state[NAME].results
export const getShowResults = (mapId) => (state) => state[NAME].showResults[mapId]
export const getIsSearching = (state) => state[NAME].isSearching
export const getHasSearched = (state) => state[NAME].hasSearched